export const enum MAINTENANCE_SOCKETS {
  MAINTENANCE_CHANGED = "maintenanceChanged"
}

export interface IMaintenanceResponse {
  isUnderMaintenance: boolean
}
